<template>
  <div class="Alpha-Post-Info">
    <div class="Alpha-Post-Info__item">
      <time class="Alpha-Post-Info__el Alpha-Post-Info__el--no-hover">{{ get_time }}</time>
    </div>
    <div class="Alpha-Post-Info__item" v-if="get_isShowAuthor">
      <router-link class="Alpha-Post-Info__el" :to="get_pathObj">{{ get_authorName }}</router-link>
    </div>
    <template v-if="get_isShowChannels">
      <div class="Alpha-Post-Info__item" :class="get_firstItemClass(index)" v-for="(channel, index) in get_channels" :key="channel.id">
        <button class="Alpha-Post-Info__el" @click="activeChannel(channel)">{{ channel.name }}</button>
      </div>
    </template>
    <template v-if="get_isPodcast">
      <div class="Alpha-Post-Info__item">
        <button class="Alpha-Post-Info__el Alpha-Post-Info__el--no-hover">Подкасты</button>
      </div>
    </template>
    <div class="Alpha-Post-Info__item Alpha-Post-Info__item--no-point" v-if="get_isBookmark">
      <button class="Alpha-Post-Info__el">
        <StarIcon class="Alpha-Post-Info__star" :color="'var(--orange-500)'"/>
        В избранном
      </button>
    </div>
  </div>
</template>

<script setup>
import {defineProps, computed} from 'vue';
import {Props} from './scripts/props.js';
import {useStore} from 'vuex';
import {formatTime_h_min} from '@shared/utils/time/formated.js';
import {PATHS_NAME} from "@shared/routers/consts/pathsName";
//---------------------------
import StarIcon from '@svg/Star.vue';
import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
//---------------------------
const store = useStore();
const props = defineProps(Props());
//---------------------------
const ID = props.postId;
//---------------------------
//Получить пост для добавления в избраннное
const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID] || props.post);
//Получить информацию об информации наличия поста в избранном
const get_bookmarkData = computed(() => get_post.value.reactions?.bookmarked);
//Получить информацию о том, добавлен ли пост в избранное или нет
const get_isBookmark = computed(() => get_bookmarkData.value?.is_mine);
//Пост является подкастом
const get_isPodcast = computed(() => get_post.value.news_atributes?.is_podcast === true);
//Отображать ли информацию об авторе поста
const get_isShowAuthor = computed(() => get_post.value.author.name && !get_isPodcast.value)
//Получить имя пользователя
const get_authorName = computed(() => get_post.value.author.name);
//Получить имя профиля пользователя
const get_userName = computed(() => get_post.value.author.username);
//Получить аватар пользователя
const get_authorAvatar = computed(() => get_post.value.author.avatar);
//Получить отформатированное время
const get_time = computed(() => formatTime_h_min(get_post.value.publication_date));
//Имеет ли данный пост каналы
const get_isShowChannels = computed(() => get_post.value.channels?.length > 0 && !get_isPodcast.value);
//Получить массив с каналами
const get_channels = computed(() => get_post.value.channels);
//Отображать полосу слева только для первых элементов данного типа
const get_firstItemClass = (index) => {
  return index > 0 ? 'Alpha-Post-Info__item--no-border' : ''
};
//Получить объект перехода
const get_pathObj = computed(() => {
  return (get_userName.value === store.state.UserSystem.user.username) ?
    {name: PATHS_NAME.USER.SETTINGS} :
    {name: PATHS_NAME.OTHER_USERS.PROFILE, params: {username: get_userName.value}};
});
//----------------------------
//Активировать канал
const activeChannel = (channel) => {
  if (store.state.ContentSystem.idChannelActive === channel.id) return;
  store.commit('ContentSystem/toSetIdActiveChannel', channel.id);
  store.dispatch('ContentSystem/toGetFilteredPosts');
}
</script>

<style lang="scss">
@import "./styles/_conf";
</style>
